// 用于将用','分隔的字符串转换为数组
// 例如：'a,b,c' => ['a', 'b', 'c']
export const string2Array = (str?: string) => {
  if (typeof str === 'string') {
    return str
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }
  return [];
};

/**
 * @description: 将数组转换为字符串
 * @param {string[]} arr 字符串数组
 * @returns {string} 字符串
 */
export const array2String = (arr?: string[]) => {
  if (!arr || !Array.isArray(arr)) {
    return undefined;
  }
  return arr.filter((item) => typeof item !== 'object' && typeof item !== 'function').join(',');
};

/**
 * @name fmtStr
 * @description 字符串拼接函数，第一个参数为模板字符串，后面的参数按顺序替换模板中的占位符 $1, $2...
 * @param {string} template 模板字符串，包含 ${number} 格式的占位符
 * @param {...unknown[]} values 替换值，按顺序对应模板中的 $1, $2...
 * @returns {string | undefined} 拼接后的字符串或 undefined（参数无效时）
 * @example
 * fmtStr("this is $1 , $2 my friend!", "Tom", "hello") // "this is Tom , hello my friend!"
 * fmtStr("this is $1 , $2 my friend!")                // "this is  ,  my friend!"
 * fmtStr("", "Tom", "hello")                          // "Tomhello"
 * fmtStr("this is $2 , $1 my friend!", "hello", "Tom")// "this is Tom , hello my friend!"
 * const s6 = fmtStr('this is $1 , $2 my friend!', 'Tom', undefined) // undefined
 * const s7 = fmtStr('this is $1 , $2 my friend!', 'Tom', null)      // undefined
 * const s8 = fmtStr('this is $1 , $2 my friend!', undefined, 'hello') // undefined
 * const s9 = fmtStr({}) // undefined
 */
export function fmtStr(template: string, ...values: unknown[]): string | undefined {
  // 1. 检查模板是否为字符串类型
  if (typeof template !== 'string') return undefined;

  // 2. 检查所有替换值是否有效（不允许 null/undefined）
  if (values.some((v) => v === null || v === undefined)) return undefined;

  // 3. 处理空模板直接拼接所有值
  if (template === '') return values.map(String).join('');

  // 4. 处理模板替换
  return template.replace(/\$(\d+)/g, (_, num) => {
    const index = parseInt(num, 10) - 1;
    return index >= 0 && index < values.length ? String(values[index]) : '';
  });
}
